import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { PostMessageLogResponseDto } from "../../../types/dto/chat/send-message-log-response-dto";
import sendMessageLog from "../../../../application/utils/send-message-log";

export const sendMessageLogSubmission = createAsyncThunk<
  PostMessageLogResponseDto,
  { data: any }
>(
  "chat-slice/send-message-log",
  async (
    { data },
    { getState }
  ) => {
    const state = getState() as RootState;

    sendMessageLog(data, state["app-state"]);
  }
);
